import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'

/* Model */

export interface LogisticDashboardStateModel {
  /**
   * Nur Lieferungen mit Problem (`LogistikDashboardItemUiDto.problem`): fehlgeschlagen, Zustellproblem laut Notiz
   * oder seit mehr als 7 Tagen offen. Hiess bis 2026-09-24 `showOnlyFailures` und filterte nur Fehlschlaege.
   */
  nurProbleme?: boolean
}

export class DashboardStateLogisticSetFilter {
  static readonly type = '[Dashboard] Set Logistic Filter'
  constructor(public filter: Partial<LogisticDashboardStateModel>) {}
}
export class DashboardStateLogisticResetFilter {
  static readonly type = '[Dashboard] Reset Logistic Filter'
}

/* State */

const defaultState: LogisticDashboardStateModel = {
  nurProbleme: false,
}

@State<LogisticDashboardStateModel>({
  name: 'logisticDashboard',
  defaults: defaultState,
})
@Injectable()
export class LogisticDashboardState {
  // Logistic

  @Selector()
  static logisticFilterCounter(state: LogisticDashboardStateModel) {
    return state.nurProbleme ? 1 : 0
  }
  @Selector()
  static logisticFilter(state: LogisticDashboardStateModel) {
    return state
  }

  @Action(DashboardStateLogisticSetFilter)
  setLogisticFilter(ctx: StateContext<LogisticDashboardStateModel>, action: DashboardStateLogisticSetFilter) {
    ctx.patchState({
      ...action.filter,
    })
  }

  @Action(DashboardStateLogisticResetFilter)
  resetLogisticFilter(ctx: StateContext<LogisticDashboardStateModel>) {
    ctx.patchState({
      ...defaultState,
    })
  }
}
